import React, { useEffect } from 'react';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MissionHelp from './components/MissionHelp';
import { MissionTutorialStepsKeys, tutorialOpacity } from 'shared/utils/tutorial';
import MissionTabs from './components/MissionTabs';
import MissionCard from './components/MissionCard';
import { hasExplorerType, hasGrandType } from 'shared/screens/Missions/utils/missionsPerformance';

import ScrollContainer from 'react-indiana-drag-scroll';
import { Spinner } from 'react-bootstrap';
import Screens from 'shared/screens';
import QueryParamsProxy from 'shared/utils/queryParamProxy';
import useMissionsRequest from 'shared/screens/Missions/hooks/useMissions';

const LoadingSpinner = () => (
  <Loading>
    <Spinner animation="border" />
  </Loading>
);

const Missions = props => {
  const { navigation, missionsData, missionsAssets, assetsLoaded, activeTutorial, tutorialStep } = props;

  useEffect(() => {
    if (missionsData.length === 0) QueryParamsProxy.navigate(navigation, Screens.Home);
  }, []);

  const { filteredValue, setFilterData, filterData } = useMissionsRequest();

  return (
    <Container>
      {!assetsLoaded ? (
        <LoadingSpinner />
      ) : (
        <>
          <Background src={missionsAssets.BACKGROUND} />
          <MissionHelp missionsAssets={missionsAssets} activeTutorial={activeTutorial} />
          {/* <MissionTabs setFilterData={setFilterData} missionsAssets={missionsAssets} {...props} /> */}

          <MissionsContainerWrapper>
            <MissionsContainer opacity={tutorialOpacity(tutorialStep === MissionTutorialStepsKeys.EXPLORE)}>
              {!hasExplorerType(filterData) ? (
                <DisplayContainer>
                  <ComingSoon src={missionsAssets.COMING_SOON} />
                </DisplayContainer>
              ) : filteredValue.length === 0 ? (
                <DisplayContainer>
                  <WithoutMissions src={missionsAssets.NO_MISSIONS} />
                </DisplayContainer>
              ) : (
                <>
                  {filteredValue.map((item, index) => (
                    <MissionCard object={{ item, index }} key={item.missionId} {...props} />
                  ))}
                  {filteredValue.length === 1 && hasGrandType(filteredValue[0].missionType) && (
                    <NoExplorerMissions src={missionsAssets.NO_MISSIONS} />
                  )}
                </>
              )}
            </MissionsContainer>
          </MissionsContainerWrapper>
        </>
      )}
    </Container>
  );
};

const Loading = styled.div`
  position: absolute;
  z-index: 99;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const MissionsContainer = styled(ScrollContainer)`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 99vw;
  height: 90vh;
  overflow: hidden;
  white-space: nowrap;
  padding-top: 12vh;
  padding-right: 6vh;
`;

const Container = styled.div`
  height: 100%;
  align-items: center;
`;

const MissionsContainerWrapper = styled.div`
  width: 99vw;
  padding-left: 5vh;
  box-sizing: border-box;
  overflow: hidden;
`;

const Background = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
  width: 100%;
  height: 100%;
`;

const WithoutMissions = styled.img`
  max-height: 50vh;
  margin-top: 10vh;
`;

const NoExplorerMissions = styled.img`
  max-height: 35vh;
  margin-left: calc(33vw - 26vh);
  align-self: center;
`;

const DisplayContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const ComingSoon = styled.img`
  height: 14vh;
  width: 120vh;
  margin-top: 28vh;
`;

export default Missions;

